import { Component, OnInit } from '@angular/core';
import { PostService } from '../post.service';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-post',
  templateUrl: './post.component.html',
  styleUrls: ['./post.component.css']
})
export class PostComponent implements OnInit {
  public loading = false;

  public post_list: Array<any>;

  public post_type: string;

  public max_page_array: Array<any>;

  public hideme=[];

  public missing_alt_count=[];

  constructor(private post: PostService) { 
      this.post_type = 'post';
      this.post.reset_post_type(this.post_type);

  }

  /* get any kind of post list */
  get_post_list(){

    this.loading = true;
    this.post_list_subscriber();

  }

  /* Media list subscriber function */
  post_list_subscriber(){

    this.post.get_post_list().subscribe((res)=>{

      let data_received = res.json();
      this.post_list = data_received['data'];
      console.log(this.post_list.length);
      this.post.max_pages = data_received['max_pages'];
      this.max_page_array = Array(this.post.max_pages).fill(undefined);
      this.loading = false;
      this.missing_alt_total(this.post_list);
    },
    (error)=>{
      let data_received = error.json();
      alert(data_received.message);
      this.loading = false;
    }
    );


  }

  /* setting missing alt count */
  missing_alt_total(data){
    for(let post of data){
      let count = 0;
      for(let image of post['images']){
        if(image.alt==""){
          count++;
        }
      }
      this.missing_alt_count[post.id] = count;
    }
  }

  /* get media list bsed on media type selected */
  change_post_type($event){

    this.loading = true;
    this.post.reset_post_type(this.post_type);
    this.post_list_subscriber();

  }

   /* Update Single Media */
   update_post(index, $event){
    
    this.loading = true;
    this.post.update_post([this.post_list[index]]).subscribe(res => {
      let result = res.json();
      this.missing_alt_total(this.post_list);
      this.loading = false;
    });

  }

  /* Next page */
  next_page($event){
    if(this.post.next_page()){
      this.get_post_list();
    }
  }

  /* Previous page */
  previous_page($event){
    if(this.post.previous_page()){
      this.get_post_list();
    }
  }

  /* Go to perticular page */
  go_to_page(i,$event){
    if(i <= this.post.max_pages && i != this.post.page_number){
      this.post.page_number = i;
      this.get_post_list();
    }
  }

  /* This function will add alt to all the image of this perticular post */
  add_to_all(alt, index){
    (this.post_list[index].images).forEach(function(image){
      
     
        if(alt != "" && image.alt == ""){
          image.alt = alt;
        }
      

    });
  }

  ngOnInit() {
    this.get_post_list();
  }

}



// WEBPACK FOOTER //
// E:/UniServerZ/www/seo/wp-content/plugins/dvin508-ada-seo/seo/src/app/post/post.component.ts